class MatchHistoryTable
{
	static attachTableEvents(matchHistoryContainer){
		matchHistoryContainer.on('click', '.game_master .opponent', function(e){
			let target = $(e.target);
			if(target.hasClass('username'))
			{
				return;
			}
			$(this).toggleClass('selected');
		});
	}
}

export {MatchHistoryTable};
